var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcContentPaste24Px(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 19.556,
    viewBox: "0 0 16 19.556",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_content_paste_24px",
    d: "M17.222,1.778H13.507a2.656,2.656,0,0,0-5.013,0H4.778A1.783,1.783,0,0,0,3,3.556V17.778a1.783,1.783,0,0,0,1.778,1.778H17.222A1.783,1.783,0,0,0,19,17.778V3.556A1.783,1.783,0,0,0,17.222,1.778ZM11,1.778a.889.889,0,1,1-.889.889A.892.892,0,0,1,11,1.778Zm6.222,16H4.778V3.556H6.556V6.222h8.889V3.556h1.778Z",
    transform: "translate(-3)",
    fill: "#354a5f"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcContentPaste24Px);
export default __webpack_public_path__ + "static/media/ic_content_paste_24px.bd34817acf87ad611e5f81ec441431d3.svg";
export { ForwardRef as ReactComponent };